import { render, staticRenderFns } from "./NavigationTitle.vue?vue&type=template&id=2af6dc5c&scoped=true&"
import script from "./NavigationTitle.vue?vue&type=script&lang=js&"
export * from "./NavigationTitle.vue?vue&type=script&lang=js&"
import style0 from "./NavigationTitle.vue?vue&type=style&index=0&id=2af6dc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6dc5c",
  null
  
)

export default component.exports